module.exports = __webpack_public_path__ + "static/media/faded-hexagons-background.1936eb6a.png";